module.exports = __webpack_public_path__ + "static/cloud_logo-02615c777fea90e1d3b6c78e4eb4c393.png";